<template>
    <Icon
        :name="name"
        :width="width"
        :height="height"
        :color="color"
        @click="$emit('click')"
    >
        <circle class="a" cx="5.25" cy="20.997" r="2.25" />

        <polyline
            class="a"
            points="7.369 21.747 15 23.247 19.5 5.247 4.5 5.247 4.5 18.875"
        />

        <path
            class="a"
            d="M16.5.747H6a1.5,1.5,0,0,0-1.5,1.5v3H21A4.5,4.5,0,0,0,16.5.747Z"
        />
    </Icon>
</template>

<script>
import Icon from '@/components/icons/Icon'

export default {
    name: 'BinIcon',
    components: {
        Icon,
    },
    props: {
        name: {
            type: String,
            default: '',
        },
        width: {
            type: [Number, String],
            default: 18,
        },
        height: {
            type: [Number, String],
            default: 18,
        },
        color: {
            type: String,
            default: '#000',
        },
    },
}
</script>

<style lang="scss" scoped>
.a {
    fill: none;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 1.5px;
}
</style>
